export default {"src":"/_next/static/media/IT.1f9b0ca5.svg","height":355,"width":512,"blurWidth":0,"blurHeight":0};